export const FETCH_AUTH_REQUEST = 'FETCH_AUTH_REQUEST';
export const FETCH_AUTH_SUCCESS = 'FETCH_AUTH_SUCCESS';
export const FETCH_AUTH_FAILURE = 'FETCH_MESSAGES_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const FETCH_CHAT_REQUEST = 'FETCH_CHAT_REQUEST';
export const FETCH_CHAT_SUCCESS = 'FETCH_CHAT_SUCCESS';
export const FETCH_CHAT_FAILURE = 'FFETCH_CHAT_FAILURE';
export const FETCH_CHANGE_CHAT_STATUS = 'FETCH_CHANGE_CHAT_STATUS';
export const CHANGE_CHAT_STATUS = 'CHANGE_CHAT_STATUS';
export const GET_CHAT = 'GET_CHAT';
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE';
export const FETCH_ADD_NEW_MESSAGE = 'FETCH_ADD_NEW_MESSAGE';
export const FETCH_USER_DIALOG_SETTINGS_REQUEST = 'FETCH_USER_DIALOG_SETTINGS_REQUEST';
export const FETCH_USER_DIALOG_SETTINGS_SUCCESS = 'FETCH_USER_DIALOG_SETTINGS_SUCCESS';
export const FETCH_USER_DIALOG_SETTINGS_FAILURE = 'FETCH_USER_DIALOG_SETTINGS_FAILURE';
export const CHAT_TYPING = 'CHAT_TYPING';
export const FETCH_CHANGE_AVATAR = 'FETCH_CHANGE_AVATAR';
export const CHANGE_AVATAR = 'CHANGE_AVATAR';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const FETCH_UPDATE_PROFILE = 'FETCH_UPDATE_PROFILE';
export const FETCH_UPDATE_USER_DIALOG_SETTINGS = 'FETCH_USER_DIALOG_SETTINGS';
export const UPDATE_USER_DIALOG_SETTINGS = 'UPDATE_USER_DIALOG_SETTINGS';
export const OPEN_CHATLIST = 'OPEN_CHATLIST';
export const CLOSE_CHATLIST = 'CLOSE_CHATLIST';
export const FETCH_AUTH_SIGNUP = 'FETCH_AUTH_SIGNUP';
export const FETCH_GOOGLE_AUTH = 'FETCH_GOOGLE_AUTH';
export const FETCH_GITHUB_AUTH = 'FETCH_GITHUB_AUTH';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const FETCH_LOGOUT = 'FETCH_LOGOUT';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
